import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { PRODUCT_CATEGORIES } from "../constants/categories.js";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  serverTimestamp,
  updateDoc,
  increment,
} from "firebase/firestore";
import { db } from "../firebase";
import "../styles/AddProduct.css";

const IMGBB_KEY = process.env.REACT_APP_IMGBB_KEY;

export default function AddProduct() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { shopId } = useParams();

  const [loading, setLoading] = useState(false);

  const [preview, setPreview] = useState("");

  const [image, setImage] = useState(null);

  const [form, setForm] = useState({
    name: "",
    description: "",
    category: "",
    brand: "",
    price: "",
    offerPrice: "",
    stock: "",
    active: true,
  });

  

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]:
        e.target.type === "checkbox"
          ? e.target.checked
          : e.target.value,
    });
  };

  const chooseImage = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setImage(file);

    setPreview(URL.createObjectURL(file));
  };

  async function uploadImage() {
    if (!image) return "";

    const body = new FormData();

    body.append("image", image);

    const res = await fetch(
      `https://api.imgbb.com/1/upload?key=${IMGBB_KEY}`,
      {
        method: "POST",
        body,
      }
    );

    const data = await res.json();

    return data.data.url;
  }

  async function saveProduct() {
    try {
      setLoading(true);

      const shopRef = doc(db, "shops", shopId);

      const shopSnap = await getDoc(shopRef);

      if (!shopSnap.exists()) {
        alert("Shop not found");
        return;
      }

      const shop = shopSnap.data();

      if (shop.uid !== user.uid) {
        alert("Unauthorized");
        return;
      }

      const imageUrl = await uploadImage();

      await addDoc(collection(db, "shopproducts"), {
        shopId,

        ownerUid: user.uid,

        shopName: shop["Shop Name"],

        ownerName: shop.ownerName || "",

        image: imageUrl,

        ...form,

        price: Number(form.price),

        offerPrice: Number(form.offerPrice),

        stock: Number(form.stock),

        createdAt: serverTimestamp(),

        updatedAt: serverTimestamp(),
      });

      await updateDoc(shopRef, {
        productCount: increment(1),
      });

      alert("Product Added");

      navigate(`/shop/manage/${shopId}`);

    } catch (err) {
      console.error(err);

      alert("Failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="add-product-page">

      <div className="product-card">

        <h2>Add Product</h2>

        <label className="image-upload">

          {preview ? (
            <img
              src={preview}
              alt=""
              className="preview-image"
            />
          ) : (
            <div className="upload-placeholder">
              📷 Upload Product Image
            </div>
          )}

          <input
            type="file"
            hidden
            accept="image/*"
            onChange={chooseImage}
          />

        </label>

        <input
          name="name"
          placeholder="Product Name"
          value={form.name}
          onChange={handleChange}
        />

        <textarea
          rows="4"
          name="description"
          placeholder="Description"
          value={form.description}
          onChange={handleChange}
        />

       <select
  name="category"
  value={form.category}
  onChange={handleChange}
>
  <option value="">
    Select Category
  </option>

  {PRODUCT_CATEGORIES.map((cat) => (
    <option
      key={cat.name}
      value={cat.name}
    >
      {cat.name}
    </option>
  ))}
</select>

        <input
          name="brand"
          placeholder="Brand"
          value={form.brand}
          onChange={handleChange}
        />

        <div className="price-row">

          <input
            type="number"
            name="price"
            placeholder="Price"
            value={form.price}
            onChange={handleChange}
          />

          <input
            type="number"
            name="offerPrice"
            placeholder="Offer Price"
            value={form.offerPrice}
            onChange={handleChange}
          />

        </div>

        <input
          type="number"
          name="stock"
          placeholder="Available Stock"
          value={form.stock}
          onChange={handleChange}
        />

        <label className="toggle">

          <input
            type="checkbox"
            name="active"
            checked={form.active}
            onChange={handleChange}
          />

          Active Product

        </label>

        <button
          className="save-product-btn"
          onClick={saveProduct}
          disabled={loading}
        >
          {loading
            ? "Saving..."
            : "Save Product"}
        </button>

      </div>

    </div>
  );
}